(function () {
  function getPageMargin() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--page-margin');
    var n = parseFloat(v);
    return isNaN(n) ? 24 : n;
  }

function computeMaxColumnWidth(panel) {
    var links = panel.querySelectorAll('.mega-menu__link');
    var max = 0;
    links.forEach(function (link) {
      if (link.scrollWidth > max) max = link.scrollWidth;
    });
    return Math.ceil(max);
  }

  function alignPanel(trigger) {
    var li = trigger.closest('.menu-list__list-item');
    if (!li) return;
    var panel = li.querySelector('.mega-menu');
    if (!panel) return;

    // Belt-and-suspenders: the CSS file also sets these, but setting them
    // here too means alignment still works even if a specificity fight
    // elsewhere wins over the stylesheet rule.
    panel.style.width = 'fit-content';
    panel.style.maxWidth = 'calc(100% - 80px)';
    panel.style.transform = '';

    // Fixed column sizing: use the single widest link in THIS panel (varies
    // per category — "Recliners & Massage Chairs" vs a shorter list
    // elsewhere) as a uniform width for all 4 columns, so every column
    // lines up to the same marker instead of each sizing independently.
    var list = panel.querySelector('.mega-menu__list');
    if (list) {
      var maxWidth = computeMaxColumnWidth(panel);
      if (maxWidth > 0) {
        list.style.gridTemplateColumns = 'repeat(4, ' + maxWidth + 'px)';
      }
    }

    requestAnimationFrame(function () {
      var panelRect = panel.getBoundingClientRect();
      var triggerRect = trigger.getBoundingClientRect();
      var pageMargin = getPageMargin();

      var delta = triggerRect.left - panelRect.left;

      var maxLeft = window.innerWidth - pageMargin - panelRect.width;
      var proposedLeft = panelRect.left + delta;
      if (proposedLeft > maxLeft) {
        delta -= (proposedLeft - maxLeft);
      }

      var minLeft = pageMargin;
      var proposedLeft2 = panelRect.left + delta;
      if (proposedLeft2 < minLeft) {
        delta += (minLeft - proposedLeft2);
      }

      panel.style.transform = 'translateX(' + Math.round(delta) + 'px)';
    });
  }

  function init() {
    var triggers = document.querySelectorAll('.menu-list__link[aria-haspopup]');
    triggers.forEach(function (trigger) {
      var li = trigger.closest('.menu-list__list-item');
      if (!li) return;
      li.addEventListener('mouseenter', function () { alignPanel(trigger); });
      trigger.addEventListener('focus', function () { alignPanel(trigger); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    var hovered = document.querySelector('.menu-list__list-item:hover .menu-list__link[aria-haspopup]');
    if (hovered) alignPanel(hovered);
  });
})();